import { SvgIcon, SvgIconProps } from '@mui/material'

const BackpackOutlinedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.5 5V4C16.5 3.46957 16.2893 2.96086 15.9142 2.58579C15.5391 2.21071 15.0304 2 14.5 2H10.5C9.96957 2 9.46086 2.21071 9.08579 2.58579C8.71071 2.96086 8.5 3.46957 8.5 4V5C7.43913 5 6.42172 5.42143 5.67157 6.17157C4.92143 6.92172 4.5 7.93913 4.5 9V20C4.5 20.5304 4.71071 21.0391 5.08579 21.4142C5.46086 21.7893 5.96957 22 6.5 22H18.5C19.0304 22 19.5391 21.7893 19.9142 21.4142C20.2893 21.0391 20.5 20.5304 20.5 20V9C20.5 7.93913 20.0786 6.92172 19.3284 6.17157C18.5783 5.42143 17.5609 5 16.5 5ZM10.5 4H14.5V5H10.5V4ZM12.5 9L14.5 11L12.5 13L10.5 11L12.5 9ZM18.5 20H6.5V16H8.5V18H9.5V16H18.5V20ZM18.5 15H6.5V9C6.5 8.46957 6.71071 7.96086 7.08579 7.58579C7.46086 7.21071 7.96957 7 8.5 7H16.5C17.0304 7 17.5391 7.21071 17.9142 7.58579C18.2893 7.96086 18.5 8.46957 18.5 9V15Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default BackpackOutlinedIcon
